// AUTO-GENERATED by scripts/gen-assets.mjs — DO NOT EDIT BY HAND.
// Add/rename raster assets in src/assets/raster (kebab-case, subfolders allowed) and run `yarn assets:gen`.

import DeviceModelFmc125130Raster from './device/model/fmc-125-130.png';
import DeviceModelSkbiel03Raster from './device/model/skbiel-03.png';
import DeviceModelSkbrCtrlRaster from './device/model/skbr-ctrl.png';
import DeviceModelSkdoel01Raster from './device/model/skdoel-01.png';
import DeviceModelSkdoel02Raster from './device/model/skdoel-02.png';
import DeviceModelSkdoel03Raster from './device/model/skdoel-03.png';
import DeviceModelSktrelRaster from './device/model/sktrel.png';

/** Maps a raster token to its bundled URL. Consume via <RasterImage name="..." />. */
export const rasterRegistry = {
	'device/model/fmc-125-130': DeviceModelFmc125130Raster,
	'device/model/skbiel-03': DeviceModelSkbiel03Raster,
	'device/model/skbr-ctrl': DeviceModelSkbrCtrlRaster,
	'device/model/skdoel-01': DeviceModelSkdoel01Raster,
	'device/model/skdoel-02': DeviceModelSkdoel02Raster,
	'device/model/skdoel-03': DeviceModelSkdoel03Raster,
	'device/model/sktrel': DeviceModelSktrelRaster,
} satisfies Record<string, string>;

/** Union of every raster token, e.g. 'device/model/skbiel-03'. */
export type RasterImageName = keyof typeof rasterRegistry;

export const rasterImageNames = Object.keys(rasterRegistry) as RasterImageName[];
